<div class="unauthenticated-resource">
  <div class="unauthenticated-resource__container">
    <h1 class="unauthenticated-resource__title" [innerHTML]="article.title | emojiHtml"></h1>
    <article class="unauthenticated-resource__body" [innerHTML]="processedContent"></article>
  </div>
</div>
